import {
  EMPLOYMENT_LOADING,
  EMPLOYMENT_STATUS_SUCCESS,
  POST_TAXPAYER_EMPLOYMENT_STATUS_SUCCESS,
  POST_SPOUSE_EMPLOYMENT_STATUS_SUCCESS,
  TAXPAYER_EMPLOYMENT_SUCCESS,
  SPOUSE_EMPLOYMENT_SUCCESS,
  EMPLOYMENT_ERROR,
  MARITAL_STATUS_REQUEST_SUCCESS,
  NEW_TAXPAYER_JOB_SUCCESS,
  NEW_SPOUSE_JOB_SUCCESS,
  DELETE_TAXPAYER_JOB_SUCCESS,
  DELETE_SPOUSE_JOB_SUCCESS,
  EDIT_TAXPAYER_JOB_SUCCESS,
  EDIT_SPOUSE_JOB_SUCCESS,
  TAXPAYER_JOB_ITEM_SUCCESS,
  SPOUSE_JOB_ITEM_SUCCESS,
  REAL_ESTATE_LOADING,
  REAL_ESTATE_SUCCESS,
  REAL_ESTATE_ERROR,
  NEW_REAL_ESTATE_SUCCESS,
  DELETE_REAL_ESTATE_SUCCESS,
  EDIT_REAL_ESTATE_SUCCESS,
  REAL_ESTATE_ITEM_SUCCESS,
  VEHICLES_LOADING,
  VEHICLES_SUCCESS,
  VEHICLES_ERROR,
  NEW_VEHICLE_SUCCESS,
  DELETE_VEHICLE_SUCCESS,
  EDIT_VEHICLE_SUCCESS,
  VEHICLE_ITEM_SUCCESS,
  OTHER_ASSETS_LOADING,
  OTHER_ASSETS_SUCCESS,
  OTHER_ASSETS_ERROR,
  NEW_ASSET_SUCCESS,
  DELETE_ASSET_SUCCESS,
  EDIT_ASSET_SUCCESS,
  ASSET_ITEM_SUCCESS,
  HOUSEHOLD_SUCCESS,
  HOUSEHOLD_LOADING,
  HOUSEHOLD_ERROR,
} from '@/app/assets/store/types';

export const mutations = {
  [EMPLOYMENT_LOADING]: (state) => {
    state.employmentLoadingStatus = 'loading';
  },
  [EMPLOYMENT_STATUS_SUCCESS]: (state, data) => {
    state.employmentLoadingStatus = 'success';
    state.employmentStatus = data;
  },
  [POST_TAXPAYER_EMPLOYMENT_STATUS_SUCCESS]: (state, status) => {
    state.employmentLoadingStatus = 'success';
    state.employmentStatus.isTaxpayerCurrentlyUnemployed = status;
    if (status === true) {
      state.taxpayerJobs = [];
    }
  },
  [POST_SPOUSE_EMPLOYMENT_STATUS_SUCCESS]: (state, status) => {
    state.employmentLoadingStatus = 'success';
    state.employmentStatus.isSpouseCurrentlyUnemployed = status;
    if (status === true) {
      state.spouseJobs = [];
    }
  },
  [TAXPAYER_EMPLOYMENT_SUCCESS]: (state, jobs) => {
    state.employmentLoadingStatus = 'success';
    state.taxpayerJobs = jobs;
  },
  [SPOUSE_EMPLOYMENT_SUCCESS]: (state, jobs) => {
    state.employmentLoadingStatus = 'success';
    state.spouseJobs = jobs;
  },
  [EMPLOYMENT_ERROR]: (state) => {
    state.employmentLoadingStatus = 'error';
  },
  [MARITAL_STATUS_REQUEST_SUCCESS]: (state, status) => {
    state.maritalStatus = status;
  },
  [NEW_TAXPAYER_JOB_SUCCESS]: (state, resp) => {
    state.employmentLoadingStatus = 'success';
    const newJob = JSON.parse(resp.config.data);
    newJob.id = resp.data.id;
    state.taxpayerJobs.push(newJob);
  },
  [NEW_SPOUSE_JOB_SUCCESS]: (state, resp) => {
    state.employmentLoadingStatus = 'success';
    const newJob = JSON.parse(resp.config.data);
    newJob.id = resp.data.id;
    state.spouseJobs.push(newJob);
  },
  [DELETE_TAXPAYER_JOB_SUCCESS]: (state, id) => {
    state.employmentLoadingStatus = 'success';
    const index = state.taxpayerJobs.findIndex(job => job.id === id);
    state.taxpayerJobs.splice(index, 1);
  },
  [DELETE_SPOUSE_JOB_SUCCESS]: (state, id) => {
    state.employmentLoadingStatus = 'success';
    const index = state.spouseJobs.findIndex(job => job.id === id);
    state.spouseJobs.splice(index, 1);
  },
  [EDIT_TAXPAYER_JOB_SUCCESS]: (state, item) => {
    state.employmentLoadingStatus = 'success';
    const index = state.taxpayerJobs.findIndex(job => job.id === item.editedItemId);
    state.taxpayerJobs.splice(index, 1, item.newJob);
  },
  [EDIT_SPOUSE_JOB_SUCCESS]: (state, item) => {
    state.employmentLoadingStatus = 'success';
    const index = state.spouseJobs.findIndex(job => job.id === item.editedItemId);
    state.spouseJobs.splice(index, 1, item.newJob);
  },
  [TAXPAYER_JOB_ITEM_SUCCESS]: (state, data) => {
    state.employmentLoadingStatus = 'success';
    state.itemDetails = data.item;
    state.itemDetails.id = data.id;
  },
  [SPOUSE_JOB_ITEM_SUCCESS]: (state, data) => {
    state.employmentLoadingStatus = 'success';
    state.itemDetails = data.item;
    state.itemDetails.id = data.id;
  },
  [REAL_ESTATE_LOADING]: (state) => {
    state.realEstateLoadingStatus = 'loading';
  },
  [REAL_ESTATE_SUCCESS]: (state, items) => {
    state.realEstateLoadingStatus = 'success';
    state.realEstate = items;
  },
  [REAL_ESTATE_ERROR]: (state) => {
    state.realEstateLoadingStatus = 'error';
  },
  [NEW_REAL_ESTATE_SUCCESS]: (state, resp) => {
    state.realEstateLoadingStatus = 'success';
    const newRealEstate = JSON.parse(resp.config.data);
    newRealEstate.id = resp.data.id;
    newRealEstate.countyName = resp.county;
    state.realEstate.push(newRealEstate);
  },
  [DELETE_REAL_ESTATE_SUCCESS]: (state, id) => {
    state.realEstateLoadingStatus = 'success';
    const index = state.realEstate.findIndex(realEstate => realEstate.id === id);
    state.realEstate.splice(index, 1);
  },
  [EDIT_REAL_ESTATE_SUCCESS]: (state, item) => {
    state.realEstateLoadingStatus = 'success';
    const index = state.realEstate.findIndex(realEstate => realEstate.id === item.editedItemId);
    state.realEstate.splice(index, 1, item.newItem);
  },
  [REAL_ESTATE_ITEM_SUCCESS]: (state, data) => {
    state.realEstateLoadingStatus = 'success';
    state.itemDetails = data.item;
    state.itemDetails.id = data.id;
  },
  [VEHICLES_LOADING]: (state) => {
    state.vehiclesLoadingStatus = 'loading';
  },
  [VEHICLES_SUCCESS]: (state, items) => {
    state.vehiclesLoadingStatus = 'success';
    state.vehicles = items;
  },
  [VEHICLES_ERROR]: (state) => {
    state.vehiclesLoadingStatus = 'error';
  },
  [NEW_VEHICLE_SUCCESS]: (state, resp) => {
    state.vehiclesLoadingStatus = 'success';
    const newVehicle = JSON.parse(resp.config.data);
    newVehicle.id = resp.data.id;
    state.vehicles.push(newVehicle);
  },
  [DELETE_VEHICLE_SUCCESS]: (state, id) => {
    state.vehiclesLoadingStatus = 'success';
    const index = state.vehicles.findIndex(vehicle => vehicle.id === id);
    state.vehicles.splice(index, 1);
  },
  [EDIT_VEHICLE_SUCCESS]: (state, item) => {
    state.vehiclesLoadingStatus = 'success';
    const index = state.vehicles.findIndex(vehicle => vehicle.id === item.editedItemId);
    state.vehicles.splice(index, 1, item.newItem);
  },
  [VEHICLE_ITEM_SUCCESS]: (state, data) => {
    state.vehiclesLoadingStatus = 'success';
    state.itemDetails = data.item;
    state.itemDetails.id = data.id;
  },
  [OTHER_ASSETS_LOADING]: (state) => {
    state.otherAssetsLoadingStatus = 'loading';
  },
  [OTHER_ASSETS_SUCCESS]: (state, items) => {
    state.otherAssets = items;
  },
  [OTHER_ASSETS_ERROR]: (state) => {
    state.otherAssetsLoadingStatus = 'error';
  },
  [NEW_ASSET_SUCCESS]: (state, resp) => {
    state.otherAssetsLoadingStatus = 'success';
    const newAsset = JSON.parse(resp.config.data);
    newAsset.id = resp.data.id;
    state.otherAssets.push(newAsset);
  },
  [DELETE_ASSET_SUCCESS]: (state, id) => {
    state.otherAssetsLoadingStatus = 'success';
    const index = state.otherAssets.findIndex(asset => asset.id === id);
    state.otherAssets.splice(index, 1);
  },
  [EDIT_ASSET_SUCCESS]: (state, item) => {
    state.otherAssetsLoadingStatus = 'success';
    const index = state.otherAssets.findIndex(asset => asset.id === item.editedItemId);
    state.otherAssets.splice(index, 1, item.newItem);
  },
  [ASSET_ITEM_SUCCESS]: (state, data) => {
    state.otherAssetsLoadingStatus = 'success';
    state.itemDetails = data.item;
    state.itemDetails.id = data.id;
  },
  [HOUSEHOLD_SUCCESS]: (state, item) => {
    state.householdLoadingStatus = 'success';
    state.household = item;
  },
  [HOUSEHOLD_LOADING]: (state) => {
    state.householdLoadingStatus = 'loading';
  },
  [HOUSEHOLD_ERROR]: (state) => {
    state.householdLoadingStatus = 'error';
  },
};
